import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfigService } from '../app-config.service';

export interface ForceAdjustedHoursResponse {
    enabled: boolean;
    message?: string;
}

@Injectable({
    providedIn: 'root'
})
export class AppSettingsService {

    private backendBaseUrl: string;

    constructor(
        private http: HttpClient,
        private appConfig: AppConfigService
    ) {
        this.backendBaseUrl = appConfig.get('backendBaseUrl');
    }

    /**
     * Get the current force adjusted hours setting
     */
    getForceAdjustedHours(): Observable<ForceAdjustedHoursResponse> {
        return this.http.get<ForceAdjustedHoursResponse>(`${this.backendBaseUrl}/api/settings/force-adjusted-hours`);
    }

    /**
     * Toggle the force adjusted hours setting
     */
    toggleForceAdjustedHours(): Observable<ForceAdjustedHoursResponse> {
        return this.http.post<ForceAdjustedHoursResponse>(`${this.backendBaseUrl}/api/settings/force-adjusted-hours/toggle`, {});
    }
}